<div class="mb-4">
  <h3 class="color-theme font-weight-bold mb-0">
    {{ "Impostazione lingua" | translate }}
  </h3>
</div>
<div class="language-container">
  <div class="card">
    <div class="card-body">
      <table class="table manage-table">
        <thead>
          <tr>
            <th scope="col" class="col-languages">
              {{ "Lingua" | translate }}
            </th>
            <th scope="col" class="col-languages">
              {{ "Abbreviazione" | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let element of allLanguages">
            <td>{{ element.language }}</td>
            <td>{{ element.abr }}</td>
            <td
              style="
                border-right: 1px solid rgba(0, 0, 0, 0.125);
                border-bottom: 1px solid rgba(0, 0, 0, 0.125);
                padding: 0;
                width: 10%;
              "
            >
              <div
                class="deleteImg"
                data-toggle="modal"
                data-target="#delLanguageModal"
                (click)="setLanguageToDelete(element)"
              >
                <img
                  src="assets/img/Pittogramma elimina - cestino.png"
                  style="width: 30px"
                  alt=""
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="manage-toolbar">
        <button
          class="pl-4 pr-4 mt-2 btn btn-secondary"
          data-toggle="modal"
          data-target="#languageModal"
        >
          + {{ "Aggiungi Lingua" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="languageModal"
  data-backdrop="static"
  data-keyboard="false"
  tabindex="-1"
  role="dialog"
  aria-labelledby="languageModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="languageModalLabel">
          {{ "Aggiungi una lingua" | translate }}
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="language-form">
          <form>
            <div class="form-group">
              <label for="language">{{ "Lingua" | translate }}</label>
              <input
                [(ngModel)]="newLanguage.language"
                name="language"
                type="text"
                class="form-control"
                id="language"
                aria-describedby="language"
              />
            </div>
            <div class="form-group">
              <label for="abr">{{ "Abbreviazione" | translate }}</label>
              <input
                [(ngModel)]="newLanguage.abr"
                name="abr"
                type="text"
                class="form-control"
                id="abr"
                aria-describedby="abr"
              />
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          {{ "Annulla" | translate }}
        </button>
        <button
          data-dismiss="modal"
          type="button"
          class="btn btn-primary ml-2 pl-4 pr-4"
          (click)="saveNewLanguage()"
        >
          {{ "Salva" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="delLanguageModal"
  data-backdrop="static"
  data-keyboard="false"
  tabindex="-1"
  role="dialog"
  aria-labelledby="delLanguageModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="delLanguageModalLabel">
          {{ "Elimina una lingua" | translate }}
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        {{
          "Sei sicuro di voler eliminare questa lingua? Eliminare una lingua in uso da parte di categorie o servizi può causare problemi e errori"
            | translate
        }}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          {{ "Annulla" | translate }}
        </button>
        <button
          data-dismiss="modal"
          type="button"
          class="btn btn-primary ml-2 pl-4 pr-4"
          data-toggle="modal"
          data-target="#delConfirmLanguageModal"
        >
          {{ "Elimina" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="delConfirmLanguageModal"
  data-backdrop="static"
  data-keyboard="false"
  tabindex="-1"
  role="dialog"
  aria-labelledby="delConfirmLanguageModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="delConfirmLanguageModalLabel">
          {{ "Elimina una lingua" | translate }}
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        {{ "Sei davvero sicuro di voler eliminare questa lingua?" | translate }}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          {{ "Annulla" | translate }}
        </button>
        <button
          data-dismiss="modal"
          type="button"
          class="btn btn-primary ml-2 pl-4 pr-4"
          (click)="deleteLanguage(languageToDelete)"
        >
          {{ "Elimina" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
